export const toCamelCase = (str: string): string => {
    return str
        .split('_')
        .map((word, index) => index === 0 ? word : word ? word[0].toUpperCase() + word.slice(1) : '')
        .join('');
};
